import BrokerIdLogo from './BrokerIdLogo';

export default BrokerIdLogo;
